import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Is this going to make me angry/irritable?',
  a: "The taper is designed to minimize the 'spike' and 'crash.' You may feel tired, but the 'rage' associated with quitting is drastically reduced."
}, {
  q: 'Do I need to buy expensive equipment?',
  a: 'You need one refillable pod system (approx. $30) and two bottles of juice. It costs less than two disposables.'
}, {
  q: 'Can I still drink alcohol while doing this?',
  a: "Yes, but Chapter 5 gives you the 'Social Shield' protocol to ensure you don't slip up while out."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-neutral-950 relative border-t border-neutral-900" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <FadeIn data-id="element-34">
          <div className="text-center mb-16" data-id="element-35">
            <h2 className="text-4xl md:text-5xl font-black uppercase mb-6" data-id="element-36">
              Frequently Asked Questions
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-38">
              <div className="border border-neutral-800 bg-[#111] overflow-hidden" data-id="element-39">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-neutral-900 transition-colors" data-id="element-40">
                  <span className="font-display font-bold text-lg text-white" data-id="element-41">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === i ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-42">
                    <ChevronDown className="text-toxic" data-id="element-43" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-44">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-45">
                      <div className="p-6 pt-0 text-neutral-400 leading-relaxed border-t border-neutral-800/50 mt-2" data-id="element-46">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}